import { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/components/ui/carousel";
import { allTilbehorImages } from "@/data/tilbehor";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

const accessoryCategories = [
  "Slips",
  "Hårbøyler",
  "Sko og strømpebukser",
  "Rengjøringsutstyr",
  "Paraplyer",
];

const Accessories = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: "start" },
    [Autoplay({ delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true })]
  );

  return (
    <section id="tilbehor" aria-labelledby="accessories-heading" className="section-padding bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <p className="text-primary font-sans text-xs tracking-[0.3em] uppercase mb-4">
              Komplett utstyr
            </p>
            <h2 id="accessories-heading" className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-6 leading-tight">
              Tilbehør
            </h2>
            <p className="text-muted-foreground font-sans leading-relaxed mb-8">
              Vi tilbyr et bredt utvalg av tilbehør for å gjøre bunaden din komplett. 
              Alt fra sko og hårbøyler til paraplyer og rengjøringsprodukter. 
              Kontakt oss hvis du skulle lure på noe.
            </p>
            <ul className="grid grid-cols-2 gap-3 mb-8">
              {accessoryCategories.map((item) => (
                <li 
                  key={item}
                  className="flex items-center gap-2 text-foreground font-sans text-sm"
                >
                  <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                  {item}
                </li>
              ))}
            </ul>
            
            {/* Link to accessories page */}
            <Link
              to="/tilbehor"
              className="inline-flex items-center gap-2 text-primary hover:gap-3 transition-all font-sans text-sm"
            >
              Se alt tilbehør <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          
          {/* Auto-scroll Carousel */}
          <div className="relative overflow-hidden" ref={emblaRef}>
            <div className="flex">
              {allTilbehorImages.map((image, index) => (
                <div key={index} className="flex-[0_0_100%] min-w-0 pl-4 first:pl-0">
                  <div className="aspect-square overflow-hidden bg-cream">
                    <img
                      src={image}
                      alt={`Bunadstilbehør – bilde ${index + 1}`}
                      loading="lazy"
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accessories;
